import { Navigate, useLocation } from "react-router-dom";
import type { ReactElement } from "react";
import { useAuth } from "./../AuthProvider/AuthProvider";

export function MemberRoute({ children }: { children: ReactElement }) {
  let auth = useAuth();
  let location = useLocation();

  if (!auth.currentUser) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}
